<template>
  <footer class="bg-purple-ap-100 p-4 shadow-md flex justify-center">
    <div class="max-w-4xl w-screen py-20 flex flex-col items-center justify-around col lg:flex-row">
      <div class="mb-6 lg:mb-0">
        <h3 class="text-6xl text-white font-sil font-bold">CHI Au Pair</h3>
        <h5 class="text-white -mt-5">by Cultural Homestay International</h5>
      </div>
      <div class="text-left">
        <p class="text-3xl py-4 border-b border-white flex items-center">
          <i class="text-white material-icons mr-3">phone</i>
          <a class="text-white hover:text-white" href="tel:+18004324643">1-800-432-4643</a>
        </p>
        <p class="text-2xl py-4 border-b border-white flex items-center">
          <i class="text-white material-icons mr-3">mail</i>
          <a
            class="text-white hover:text-white"
            href="mailto:chiaupairops@chinet.org"
          >chiaupairops@chinet.org</a>
        </p>
        <p class="text-2xl py-4 flex items-center">
          <i class="text-white material-icons mr-3">map</i>
          <a class="text-white hover:text-white" href="https://goo.gl/maps/mbFqyqrLZoyRuNRj6">
            255 W End Avenue
            <br />San Rafael, CA 94901
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter"
};
</script>

<style scoped>
a {
  transition: all 0.2s;
}

a:hover {
  transform: scale(1.1);
  transition: all 0.2s;
}
</style>
